/** Opções de filtro dos tipos das atividades */
export enum AtividadeFilterTipoOption {
    /** Opção padrão que filtra os tipos informados */
    Default = 1,
    /** Obrigatório ter ao menos um tipo sendo filtrado e se não tiver nenhum tipo informado, então será considerado o tipo -1 para não trazer nenhum resultado */
    Required = 2,
    /** Ignora o filtro dos tipos */
    Ignore = 3
};

/** Verifica se é a opção padrão do filtro dos tipos que filtra os tipos informados */
export function isFilterTipoOptionDefault(tipoOption: AtividadeFilterTipoOption): boolean {
    return tipoOption === AtividadeFilterTipoOption.Default
}

/** Verifica se é a opção que é obrigatório ter pelo menos um tipo informado no filtro */
export function isFilterTipoOptionRequired(tipoOption: AtividadeFilterTipoOption): boolean {
    return tipoOption === AtividadeFilterTipoOption.Required
}

/** Verifica se é a opção que deve ignorar o filtro dos tipos */
export function isFilterTipoOptionIgnore(tipoOption: AtividadeFilterTipoOption): boolean {
    return tipoOption === AtividadeFilterTipoOption.Ignore
}
